<template>
  <div
    :class="[
      $style.productFlagItems,
      {
        [$style.isSmall]: isSmall === true,
        [$style.isLarge]: isSmall === false,
      },
    ]"
  >
    <div
      v-for="(flag, index) in displayedFlags"
      :key="flag.flag"
      :title="flag.awBadgeLongText || null"
      data-aw-product-flag-item
      :class="[
        $style.flagItem,
        {
          [$style.flagItemWithoutIcon]: flag.iconUrl === FLAG_REMOVE_ICON,
          [$style.flagItemDealer]: !isShop && flag.id,
          [$style.flagItemDealerSelected]: !isShop && productsStore.flagFilter === flag.id,
        },
      ]"
      :style="flagBg ? `background: ${flagBg}` : null"
      @click="flagClick(flag)"
    >
      <span :class="$style.flagItemIcon" :style="displayedFlagStyles[index]">
        <lv-icon v-if="flag.iconBindings" v-bind="flag.iconBindings" />
      </span>
      <span :class="[{[$style.flagItemTextOneLine]: oneLine}]">
        {{ flag.name }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { FLAG_REMOVE_ICON } from '~~/common/utils/productData';
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import { useProductsStore } from '~~/common/stores/products';

  const emit = defineEmits(['activate-filter']);

  const props = defineProps({
    productData: {
      type: Object,
      required: true,
    },
    flagArr: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    isSmall: {
      type: Boolean,
      default: null,
    },
    flagBg: {
      type: String,
      required: true,
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    oneLine: {
      type: Boolean,
      default: false,
    },
  });

  const displayedFlags = computed(() => {
    const allDisplayedFlags = Array.isArray(props.flagArr) ? props.flagArr : [];
    if (props.maxLength) {
      return allDisplayedFlags.slice(0, props.maxLength);
    } else {
      return allDisplayedFlags;
    }
  });

  const displayedFlagStyles = computed(() => {
    return displayedFlags.value.map((flag) => {
      const styleAttr = {};
      if (typeof flag === 'object' && flag) {
        if (flag.groupBackgroundColor) {
          styleAttr['background-color'] = flag.groupBackgroundColor;
        }
        const flagIconUrl = flag.iconUrl || flag.groupIconUrl;
        if (typeof flagIconUrl === 'string' && flagIconUrl) {
          styleAttr['background-image'] = `url(${flagIconUrl})`;
        }
      }
      return styleAttr;
    });
  });

  const isShop = __AW_IS_SHOP__;

  const productsStore = useProductsStore();

  function flagClick (flag) {
    if (!__AW_IS_SHOP__ && flag.id) {
      if (productsStore.flagFilter === flag.id) {
        productsStore.setFlagFilter(null);
      } else {
        productsStore.setFlagFilter(flag.id);
      }
      emit('activate-filter');
    }
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.flagItem {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px 2px 2px;
  border-radius: 10px;
  background: rgba(243, 240, 237, 0.85);

  .flagItemIcon {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    color: $color-white;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: content-box;
    background-size: contain;
  }

  &.flagItemWithoutIcon {
    gap: 0;

    .flagItemIcon {
      width: 0;
      padding-right: 0;
      padding-left: 0;
    }
  }

  &Dealer {
    cursor: pointer;

    &Selected {
      border: 1px solid $color-strawberry-500;
    }
  }

  &TextOneLine {
    line-height: 16px;
    display: -webkit-box;
    overflow: hidden;
    height: 16px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}

@mixin isSmallMixin {
  .flagItem {
    font-size: 10px;

    &Icon {
      width: 20px;
      height: 20px;
      padding: 2px;
      border-radius: 6px;
    }
  }
}

.productFlagItems {
  &:not(.isSmall, .isLarge) {
    @include mobile (max) {
      @include isSmallMixin;
    }
  }

  &.isSmall {
    @include isSmallMixin;
  }
}
</style>
